/**
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the IBM Public License Version 1.0 found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from "react";
import PropTypes from "prop-types";

export const TriDictionaryContext = React.createContext(null);
TriDictionaryContext.displayName = "TriDictionary";

export class TriDictionaryProvider extends React.PureComponent {
  static propTypes = {
    appMessages: PropTypes.object.isRequired,
    children: PropTypes.any,
  };

  render() {
    const { appMessages, children } = this.props;
    return (
      <TriDictionaryContext.Provider value={appMessages}>
        {children}
      </TriDictionaryContext.Provider>
    );
  }
}
